import styled from "styled-components";
import { FlexDiv } from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";

const FormWrapper = styled(FlexDiv)`
  flex-direction: column;
  gap: 24px;
`;

const HeaderContainer = styled(FlexDiv)`
  padding: 8px;
  flex-direction: column;
  gap: 8px;
`;
const HeaderTitle = styled(Typography)`
  text-align: center;
  color: ${theme.colorsV2.shyft.purple_text};
`;

const HeaderSubTitleTitle = styled(Typography)`
  text-align: center;
  color: ${theme.colorsV2.gray.shade_700};
  letter-spacing: 0.6px;
`;

const FormContainer = styled(FlexDiv)`
  flex-direction: column;
`;

const ButtonContainer = styled(FlexDiv)`
  justify-content: center;
  align-items: center;
  width: 100%;
`;
export {
  FormWrapper,
  HeaderContainer,
  HeaderTitle,
  HeaderSubTitleTitle,
  FormContainer,
  ButtonContainer,
};
